import { AuthenticationMode, Security, ConnectionStatus } from '../containers/Authentication/reducer';
import { MultiAppAuthenticationViewMode } from '../containers/MultiAppAuthentication/constants';

export default class AuthUtils {

	public static isNotConnected = (mode: AuthenticationMode | undefined): boolean => {
		return mode
			? mode.status === ConnectionStatus.NOT_CONNECTED || mode.status === ConnectionStatus.NEED_RECONNECT
			: false;
	}

	public static isConnected = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.status === ConnectionStatus.CONNECTED : false;
	}

	public static isConnecting = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.status === ConnectionStatus.CONNECTING : false;
	}

	public static needReconnecting = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.status === ConnectionStatus.NEED_RECONNECT : false;
	}

	public static isOnCache = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.onCache === true : false;
	}

	public static isExcel = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.method === Security.Excel : false;
	}

	public static isSaml = (mode: AuthenticationMode | undefined): boolean => {
		return mode ? mode.method === Security.Saml : false;
	}

	public static isLoginView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.Login;
	}

	public static isMethodView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.Method;
	}

	public static isCreationView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.Creation;
	}

	public static isCompanyView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.Company;
	}

	public static isPasswordView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.Password;
	}

	public static isOrgLoginView = (viewMode: MultiAppAuthenticationViewMode): boolean => {
		return viewMode === MultiAppAuthenticationViewMode.OrgLogin;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/authentication.ts